export const SET_YEAR = 'SET_YEAR'
export const SET_HANDOUTFILTERS = 'SET_HANDOUTFILTERS'
export const SET_CATALOG = 'SET_CATALOG'
export const SET_CMSTYPES = 'SET_CMSTYPES'
export const SET_TEXTBOOK = 'SET_TEXTBOOK'
export const SET_DEFAULTBOOK = 'SET_DEFAULTBOOK'
export const SET_BKID = 'SET_BKID'
export const SET_FORMATS = 'SET_FORMATS'
export const SET_KPS = 'SET_KPS'
export const SET_SINGLEORMULTI = 'SET_SINGLEORMULTI'
export const SET_BOOKORKPS = 'SET_BOOKORKPS'
export const SET_FACTORS = 'SET_FACTORS'
